import { useMemo } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { userHiddenClasses } from '../graphQLOperations/ClassCategories';
import { ClassCategoriesUserHiddenClassesQuery } from '../graphQLOperations/__generated__/ClassCategoriesUserHiddenClassesQuery.graphql';
import { useAppSelector } from '../redux/hooks';
import { selectUser } from '../redux/reducers/userSlice';
import { selectClassIconOverrides } from '../redux/reducers/classIconsSlice';

export const useClassIcons = (skip = false): Map<string, string> => {
  const userRedux = useAppSelector(selectUser);
  const publicUserId = userRedux?.sub ?? '';
  const overrides = useAppSelector(selectClassIconOverrides);

  const data = useLazyLoadQuery<ClassCategoriesUserHiddenClassesQuery>(
    userHiddenClasses,
    { publicUserId, skip: skip || !publicUserId },
    { fetchPolicy: 'store-or-network' },
  );

  return useMemo(() => {
    const icons = new Map<string, string>();
    (data.userByPublicUserId?.userClassCategories ?? []).forEach(category => {
      if (category?.category === 'ICON' && category.value) icons.set(category.classId, category.value);
    });
    // Session overrides win so a change this session shows immediately.
    Object.entries(overrides ?? {}).forEach(([classId, icon]) => icons.set(classId, icon));
    return icons;
  }, [data, overrides]);
};
